import { bl_fi_my_einvoice_gen_doc_to_irb_submission_history_RowClass } from '../../dbschema/bl_fi_my_einvoice_gen_doc_to_irb_submission_history.model';
import { BaseContainerModel } from '../base-container.model';

export class MyEInvoiceGenDocToIRBSubmissionHistoryContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_gen_doc_to_irb_submission_history: bl_fi_my_einvoice_gen_doc_to_irb_submission_history_RowClass = new bl_fi_my_einvoice_gen_doc_to_irb_submission_history_RowClass();
}
